import { render, staticRenderFns } from "./CadernoCursoCollapse.vue?vue&type=template&id=7499e5ee&scoped=true"
import script from "./CadernoCursoCollapse.vue?vue&type=script&lang=js"
export * from "./CadernoCursoCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7499e5ee",
  null
  
)

export default component.exports